// extracted by mini-css-extract-plugin
export default {"CommentsButton":"il_a bhr_wx bhr_jb bhr_xl bhr_i bhr_j bhr_q bhr_vt bhr_et bhr_so bhr_sp bhr_eg","CommentsButton__icon":"il_b bhr_rz"};